import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {
  onMounted,
  onUnmounted,
  ref,
  provide,
  reactive,
  inject,
  computed,
  watch,
} from 'vue';
import { pageKey } from '@drapejs/core';
import { activeDesktopFlyoutKey } from '@/keys';
import Header from './Header.vue';
import useContext from '@/composables/useContext';


export default /*#__PURE__*/_defineComponent({
  __name: 'SiteHeader',
  setup(__props) {

const { route } = useContext();

const page = inject(pageKey);
const headerTheme = ref(page?.value.fields?.HeaderTheme?.value || 'default');
const scrolledPage = ref(false);
const transparentHeader = computed(() => {
  if (!headerTheme.value || headerTheme.value === 'default') {
    return false;
  }
  return true;
});

const headerState = reactive({
  theme: headerTheme,
  scrolled: scrolledPage,
  speed: '0.2s',
});

const activeDesktopFlyout = reactive({
  isPinned: false,
  uid: null,
});
provide(activeDesktopFlyoutKey, activeDesktopFlyout);
provide('headerState', headerState);

function closeFlyout() {
  if (activeDesktopFlyout.uid) {
    activeDesktopFlyout.uid = null;
  }
}

function onScroll(e) {
  scrolledPage.value = window.scrollY > 0;
}

onMounted(() => {
  window.addEventListener('click', closeFlyout);
  window.addEventListener('scroll', onScroll);
});

onUnmounted(() => {
  window.removeEventListener('click', closeFlyout);
  window.removeEventListener('scroll', onScroll);
});

watch(
  () => route.pathname,
  () => {
    headerTheme.value = page?.value.fields?.HeaderTheme?.value || 'default';
  },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("header", {
    class: _normalizeClass(['site-header',
      {'site-header--transparent': _unref(transparentHeader),
      'site-header--scrolled': scrolledPage.value,
      'site-header--desktop-flyout': activeDesktopFlyout.uid}])
  }, [
    _createVNode(Header)
  ], 2))
}
}

})